export default __webpack_public_path__ + "static/media/group-13@2x.50578441.png";